import React from "react";
import { useCookies } from 'react-cookie';
import "./cookies.scss";

const Cookies = () => {

    const [cookies, setCookie, removeCookie] = useCookies(['accept-cookies']);

    const handleClick = () => {

        const expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 1);

        const options = {
            path: '/',
            expires: expirationDate,
        };

        setCookie('accept-cookies', true, options);
    }

    if (cookies["accept-cookies"]) {
        return null;
    }

    return (
        <cookies className="cookies">
            W celu świadczenia usług na najwyższym poziomie stosujemy pliki cookies.
            Korzystanie z naszej witryny oznacza, że będą one zamieszczane w Państwa urządzeniu.
            W każdym momencie można dokonać zmiany ustawień Państwa przeglądarki. <a href="#/policy">Zobacz politykę cookies</a>.
            <button className="rounded-button" onClick={() => handleClick()}>Zgoda</button>
        </cookies>
    );
};

export default Cookies;
